import { ScheduleSlotCompact } from './Compact';
import { ScheduleSlotContentSummary } from './ContentSummary';
import { ScheduleSlotHeader } from './Header';
import { ScheduleSlotProgress } from './Progress';
import { ScheduleSlotRoot } from './Root';

export const ScheduleSlot = {
  Root: ScheduleSlotRoot,
  Header: ScheduleSlotHeader,
  Compact: ScheduleSlotCompact,
  Progress: ScheduleSlotProgress,
  ContentSummary: ScheduleSlotContentSummary,
};
